import { render, staticRenderFns } from "./ExaminationBoardIndex.vue?vue&type=template&id=d34eeb84&scoped=true&"
import script from "./ExaminationBoardIndex.vue?vue&type=script&lang=ts&"
export * from "./ExaminationBoardIndex.vue?vue&type=script&lang=ts&"
import style0 from "./ExaminationBoardIndex.vue?vue&type=style&index=0&id=d34eeb84&lang=less&scoped=true&"
import style1 from "./ExaminationBoardIndex.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34eeb84",
  null
  
)

export default component.exports